'use client';

import { useTrackPageViewAmplitude } from '../../core/Tracking/Amplitude/Amplitude';

export function HomePageView() {
    useTrackPageViewAmplitude((ampli, defaultProperties) => {
        ampli.viewedPageIndex({
            ...defaultProperties,
        });
    });

    return null;
}
